import React, { useState } from "react";

import { TrainerGroupApi, trainersApi } from "api";
import { useTrainerGroups } from "api/hooks";
import { PaziaBreadcrumbs } from "components/atoms";
import {
  AdminResourceDeleteModal,
  AdminSearchInput,
  FiltersBackground,
  PageHeader,
  PageMain,
} from "components/molecules";
import { routes } from "consts";
import { PaziaButton } from "components/atoms";
import {
  TanTable,
  TanTableColumn,
  useFilters,
  usePagination,
  useSorting,
} from "components/molecules";
import { useNavigate } from "react-router-dom";
import { useDeleteResourceActions } from "utils/store";

export const TrainerGroupsPage = (): JSX.Element | null => {
  const { setDeleteResource } = useDeleteResourceActions();
  const [selectedTrainerGroups, setSelectedTrainerGroups] = useState<TrainerGroupApi[]>([]); // new state

  const navigate = useNavigate();

  const { searchPhrase, filter, setSearchPhrase } = useFilters();
  const { limit, onPaginationChange, skip, pagination } = usePagination();
  const { sorting, onSortingChange, fieldWithOrder } = useSorting();
  const { isLoading, isFetching, trainerGroups, total, invalidate } = useTrainerGroups(
    skip,
    limit,
    searchPhrase,
    filter,
    fieldWithOrder,
  );

  const columns = React.useMemo<TanTableColumn<TrainerGroupApi>[]>(
    () => [
      {
        id: "id",
        hideOnMobile: true,
        accessorKey: "id",
        header: "ID",
        enableColumnFilter: false,
      },
      {
        id: "name",
        accessorKey: "name",
        header: "Nazwa",
        enableColumnFilter: false,
      },
    ],
    [],
  );

  const handleDeleteSelected = async () => {
    if (!window.confirm(`Jesteś pewien że chcesz usunąć ${selectedTrainerGroups.length} grup trenerów?`)) {
      return;
    }

    try {
      await Promise.all(selectedTrainerGroups.map((group) => trainersApi.deleteTrainerGroup(group.id)));
      setSelectedTrainerGroups([]);
      invalidate();
    } catch (error) {
      console.error("Failed to delete trainer groups:", error);
      // Optionally, you could add some error handling or notification here
    }
  };

  return (
    <PageMain>
      <PaziaBreadcrumbs
        segments={[{ title: "Trenerzy", path: routes.TRAINERS }, { title: "Grupy trenerów" }]}
        className="pb-4"
      />
      <PageHeader
        button={{
          title: "Dodaj +",
          onClick: () => navigate(routes.TRAINERS_GROUPS_ADD),
        }}
      >
        Grupy trenerów
      </PageHeader>

      <FiltersBackground>
        <div className="flex flex-wrap items-center gap-2">
          <AdminSearchInput onSearch={(x) => setSearchPhrase(x)} className="self-end" />
        </div>
      </FiltersBackground>

      <div className="my-4 flex justify-end">
        <PaziaButton type="danger" disabled={selectedTrainerGroups.length < 1} onClick={handleDeleteSelected}>
          Usuń zaznaczone ({selectedTrainerGroups.length})
        </PaziaButton>
      </div>

      <TanTable
        data={trainerGroups}
        columns={columns}
        total={total}
        loading={isLoading}
        fetching={isFetching}
        onPaginationChange={onPaginationChange}
        onSortingChange={onSortingChange}
        pagination={pagination}
        sorting={sorting}
        onDelete={(x) => setDeleteResource(x.id)}
        onEdit={(x) => navigate(routes.TRAINERS_GROUPS_EDIT(x.id))}
        // @ts-ignore TODO ASDSA
        onSelectionChange={setSelectedTrainerGroups} // new prop for row selection
      />

      <AdminResourceDeleteModal
        title="Usuń grupę"
        description="Jesteś pewien że chcesz usunąć grupę trenerów?"
        onSuccessDelete={() => invalidate()}
        deleteAction={trainersApi.deleteTrainerGroup}
      />
    </PageMain>
  );
};
